import api from './api';
import toast from 'react-hot-toast';

export async function downloadExport(endpoint, params = {}, filename) {
  try {
    const resp = await api.get(endpoint, { params, responseType: 'blob' });
    const url = URL.createObjectURL(new Blob([resp.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || `KUA_Export_${new Date().toISOString().split('T')[0]}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  } catch (e) {
    toast.error('Export failed: ' + (e?.response?.data?.toString().slice(0, 100) || e.message));
  }
}
